import React, { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import Annadan from "./../assets/AnnadanSeva/Annadan.webp";
import MahaPushpaAbhieksham from "./../assets/MahaPushpaAbhieksham.webp";
import Kirtan from "./../assets/Kirtan.webp";
import MahaShankhaAbhiskem from "./../assets/MahaShankhaAbhiskem.webp";
import FlowerFestivalBanner from "./../assets/FlowerFestivalBanner.webp";
import gulabiImg from "./../assets/gulabi.webp";
import lotusImg from "./../assets/lotus.webp";
import jasmineImg from "./../assets/jasmine.webp";
import marigoldImg from "./../assets/marigold.webp";
import whiteFlowerImg from "./../assets/whiteFlower.webp";
import lilyImg from "./../assets/lily.webp";
import axios from "axios";
import AutoImageSlider from "../Components/AutoImageSlider";
import AccountDetails from "../Components/AccountDetails";

const HighLightFestival = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Flower Section
  const [quantities, setQuantities] = useState({});
  const [remainingQuantities, setRemainingQuantities] = useState({
    1: 150,
    2: 250,
    3: 250,
    4: 150,
    5: 200,
    6: 60,
  });

  // Flower data
  const flowers = [
    {
      id: 1,
      name: "Marigold flower",
      price: 50,
      unit: "kg",
      image: marigoldImg,
      required: 150,
    },
    {
      id: 2,
      name: "Jasmine flower",
      price: 350,
      unit: "kg",
      image: jasmineImg,
      required: 250,
    },
    {
      id: 3,
      name: "Gulabi flower",
      price: 200,
      unit: "kg",
      image: gulabiImg,
      required: 250,
    },
    {
      id: 4,
      name: "Lily flower",
      price: 150,
      unit: "kg",
      image: lilyImg,
      required: 150,
    },
    {
      id: 5,
      name: "Chrysanthemum flower",
      price: 160,
      unit: "Kg",
      image: whiteFlowerImg,
      required: 200,
    },
    {
      id: 6,
      name: "Lotus flower",
      price: 240,
      unit: "Dozen",
      image: lotusImg,
      required: 60,
    },
  ];

  const adjustQuantity = (id, change) => {
    setQuantities((prev) => {
      const current = prev[id] || 0;
      const remaining = remainingQuantities[id] || 0;
      const newQuantity = current + change;
      if (change > 0 && newQuantity > remaining) return prev;
      return { ...prev, [id]: newQuantity > 0 ? newQuantity : 0 };
    });
  };

  const selectedFlowers = flowers.filter((f) => (quantities[f.id] || 0) > 0);
  const flowerSevaTotal = selectedFlowers.reduce(
    (acc, f) => acc + (quantities[f.id] || 0) * f.price,
    0,
  );

  const [amount, setAmount] = useState("");
  const paymentOptions = [
    {
      amount: 550000,
      description: "One Day Anna Daan Seva",
      isHighlight: true,
    },
    { amount: 25000, plates: 500 },
    { amount: 10000, plates: 200 },
    { amount: 5000, plates: 100 },
    { amount: 2500, plates: 50 },
    { amount: 1000, plates: 20 },
  ];

  // Copy Text
  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };

  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleChange(e);
  };

  // Form Handling
  const [formData, setFormData] = useState({
    donorName: "",
    email: "",
    totalAmount: 0,
    mobileNumber: "",
    dateOfBirth: "",
    receivePrasadam: false,
    receiveCertificate: false,
    panNumber: "",
    doorNumber: "",
    houseName: "",
    streetName: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.totalAmount === 0 ||
      formData.mobileNumber === "" ||
      formData.email === "" ||
      // formData.honoreeName === "" ||
      (formData.receiveCertificate && formData.panNumber === "")
    ) {
      alert("Please enter all required fields");
      return;
    }

    let isFormDataStored = false;
    let description = "";
    const hasFlowers = quantities && Object.keys(quantities).length > 0;
    const hasAnnadaan = Number(amount) > 0;

    if (hasAnnadaan && hasFlowers) {
      const flowerList = flowers
        .filter((flower) => quantities[flower.id] > 0)
        .map(
          (flower) =>
            `${flower.name} (${quantities[flower.id]} ${flower.unit})`,
        )
        .join(", ");
      description = `Annadaan Seva & Flower Seva: ${flowerList}`;
    } else if (hasFlowers) {
      const flowerList = flowers
        .filter((flower) => quantities[flower.id] > 0)
        .map(
          (flower) =>
            `${flower.name} (${quantities[flower.id]} ${flower.unit})`,
        )
        .join(", ");
      description = `Flower Seva: ${flowerList}`;
    } else {
      description = "Annadaan Seva";
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        { amount: formData.totalAmount, currency: "INR" },
      );
      // console.log(
      //   formData.donorName,
      //   description,
      //   formData.email,
      //   formData.mobileNumber,
      // );
      const order = response.data;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: formData.totalAmount * 100,
        currency: "INR",
        name: "ISKCON Flower Festival",
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobileNumber,
        },
        donationType: description,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorEmail: formData.email,
          mobileNumber: formData.mobileNumber,
          SevaDate: new Date().toISOString(),
          ...(formData.receiveCertificate && { panNumber: formData.panNumber }),
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData },
              },
            );
            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (quantities && Object.keys(quantities).length > 0) {
                setRemainingQuantities((prev) => {
                  const updated = { ...prev };
                  Object.keys(quantities).forEach((id) => {
                    if (quantities[id] > 0)
                      updated[id] = (updated[id] || 0) - quantities[id];
                  });
                  return updated;
                });
              }
              await storeFormData("Payment Successful");
              isFormDataStored = true;
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobileNumber,
        },
        theme: { color: "#C61D21" },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const flowerDetails = Object.keys(quantities)
      .filter((id) => quantities[id] > 0)
      .map((id) => {
        const flower = flowers.find((f) => f.id === Number(id));
        return `${flower.name}:${quantities[id]}${flower.unit}`;
      })
      .join(", ");

    const storingFormData = {
      paymentStatus,
      amount: formData.totalAmount,
      donorName: formData.donorName,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      dateOfBirth: formData.dateOfBirth,
      receivePrasadam: formData.receivePrasadam ? "Yes" : "No",
      receiveCertificate: formData.receiveCertificate ? "Yes" : "No",
      panNumber: formData.panNumber,
      doorNumber: formData.doorNumber,
      houseName: formData.houseName,
      streetName: formData.streetName,
      area: formData.area,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      pincode: formData.pincode,
      flowerDetails: flowerDetails || "None",
      SevaDate: new Date().toISOString(),
    };
    const formBody = new URLSearchParams(storingFormData).toString();
    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbw4nl-Vibe_6tjQ7FhRpBPalnRBNcJ8JH6jRvsJ7wLyg7JnUUOp9XQrKyLPGtEjC12o/exec",
        {
          method: "POST",
          body: formBody,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      );
      setFormData({
        donorName: "",
        email: "",
        totalAmount: 0,
        mobileNumber: "",
        dateOfBirth: "",
        receivePrasadam: false,
        receiveCertificate: false,
        panNumber: "",
        doorNumber: "",
        houseName: "",
        streetName: "",
        area: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
      });
      setQuantities({});
      setAmount("");
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Some error occured");
    }
  };

  const getTotalAmount = () => {
    const validAmount = Number(amount) || 0;
    const validQuantities = quantities || {};
    return (
      validAmount +
      Object.keys(validQuantities).reduce((acc, id) => {
        const flower = flowers.find((f) => f.id === Number(id));
        return acc + (validQuantities[id] || 0) * (flower?.price || 0);
      }, 0)
    );
  };

  useEffect(() => {
    const totalAmount = getTotalAmount();
    setFormData((prev) => ({ ...prev, totalAmount }));
  }, [amount, quantities]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Header />

      <div className="w-full flex flex-col justify-center items-center space-y-5 md:space-y-10">
        {/* Section 1 – Hero Image */}
        <div className="w-full">
          <img
            loading="lazy"
            src={FlowerFestivalBanner}
            alt="ISKCON Vijayawada Flower Festival"
            className="w-full mt-12"
          />
        </div>

        {/* Section 2 – Intro Text */}
        <div className="w-full px-4 sm:px-8 md:px-12 py-8 bg-gradient-to-br from-orange-50 via-yellow-50 to-red-50">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 sm:p-8 md:p-10 border-2 border-[#C61D21]/20">
              <div className="text-center space-y-6">
                <p className="text-gray-800 text-base sm:text-lg md:text-xl lg:text-2xl font-medium leading-relaxed">
                  <strong className="text-[#C61D21] font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl">
                    Sri Sri Radha Shyamsundar Ji Maha Pushpabhishekam – 1000 KG
                    Flower Offering
                  </strong>
                </p>

                <div className="w-16 h-1 bg-gradient-to-r from-transparent via-[#C61D21] to-transparent mx-auto"></div>

                <p className="text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                  We are delighted to invite all devotees and well-wishers to
                  the divine celebration of Sri Sri Radha Shyamsundar Ji Maha
                  Pushpabhishekam, a grand offering of devotion with 1000
                  kilograms of fragrant flowers.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3 – Auto Image Slider */}
        <AutoImageSlider
          images={[
            {
              id: 1,
              title: "Maha Pushpa Abhieksham",
              src: MahaPushpaAbhieksham,
            },
            { id: 2, title: "Annadan", src: Annadan },
            { id: 3, title: "Maha Shankha Abhiskem", src: MahaShankhaAbhiskem },
            { id: 4, title: "Kirtan", src: Kirtan },
          ]}
          speed={30}
        />
        {/* Section 5 – Pushpa Abhishek Seva */}
        <div className="w-full lg:w-[95%] flex flex-col items-center justify-center bg-[#E2CFAF] text-center lg:border-4 border-solid border-[#C61D21]">
          <h1 className="w-full text-white bg-[#C61D21] text-2xl lg:text-4xl font-bold mb-6 p-2">
            Pushpa Abhishek Seva
          </h1>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 w-full lg:w-[98%] p-1 lg:mb-3">
            {flowers.map((flower) => (
              <div
                key={flower.id}
                className="border-4 border-solid border-[#C61D21] rounded-lg shadow-md flex flex-col items-center"
              >
                <h2 className="w-full text-white bg-[#C61D21] text-sm lg:text-xl p-1 lg:p-2 font-bold mb-2">
                  {flower.name}
                </h2>
                <img
                  loading="lazy"
                  src={flower.image}
                  alt={flower.name}
                  className="object-contain rounded-lg mb-4 p-1 w-full"
                />
                <p className="text-red-700 text-lg lg:text-xl font-semibold mb-2">
                  Per {flower.unit}: ₹{flower.price}
                </p>
                <div className="w-full px-3 mb-4">
                  <div className="flex justify-between text-xs lg:text-sm">
                    <span className="text-gray-700 font-medium">
                      Contributed
                    </span>
                    <span className="text-[#C61D21] font-semibold text-base">
                      {flower.required - remainingQuantities[flower.id]} /{" "}
                      {flower.required} {flower.unit}
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-gradient-to-r from-red to-red h-2.5 rounded-full transition-all duration-300"
                      style={{
                        width: `${((flower.required - remainingQuantities[flower.id]) / flower.required) * 100}%`,
                      }}
                    ></div>
                  </div>
                </div>
                <div className="flex items-center gap-2 lg:mb-2 mb-3">
                  <button
                    onClick={() => adjustQuantity(flower.id, -1)}
                    disabled={(quantities[flower.id] || 0) === 0}
                    className="bg-white text-black px-3 py-1 text-lg lg:text-xl rounded-md border border-black disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    -
                  </button>
                  <span className="bg-white rounded-md px-3 py-1 text-lg lg:text-xl font-bold border border-black min-w-[2.5rem] text-center">
                    {quantities[flower.id] || 0}
                  </span>
                  <button
                    onClick={() => adjustQuantity(flower.id, 1)}
                    className="bg-white text-black px-3 py-1 text-lg lg:text-xl rounded-md border border-black"
                  >
                    +
                  </button>
                </div>
                {(quantities[flower.id] || 0) > 0 && (
                  <p className="text-xs lg:text-sm text-green-800 font-semibold mb-2">
                    Subtotal: ₹
                    {(quantities[flower.id] * flower.price).toLocaleString()}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Flower Seva Summary */}
          {selectedFlowers.length > 0 && (
            <div className="w-full lg:w-[98%] bg-white border-2 border-[#C61D21] rounded-xl p-4 mb-4 mx-1">
              <h3 className="text-lg lg:text-2xl font-bold text-[#C61D21] mb-3 text-center">
                🌸 Flower Seva Summary
              </h3>
              <table className="w-full text-sm lg:text-base">
                <thead>
                  <tr className="bg-[#C61D21] text-white">
                    <th className="py-1 px-2 text-left rounded-tl-md">
                      Flower
                    </th>
                    <th className="py-1 px-2 text-center">
                      Qty ({selectedFlowers.map((f) => f.unit).join("/")})
                    </th>
                    <th className="py-1 px-2 text-center">Rate</th>
                    <th className="py-1 px-2 text-right rounded-tr-md">
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedFlowers.map((flower, idx) => (
                    <tr
                      key={flower.id}
                      className={idx % 2 === 0 ? "bg-[#FFF5EC]" : "bg-white"}
                    >
                      <td className="py-1 px-2 font-medium">{flower.name}</td>
                      <td className="py-1 px-2 text-center">
                        {quantities[flower.id]} {flower.unit}
                      </td>
                      <td className="py-1 px-2 text-center">
                        ₹{flower.price}/{flower.unit}
                      </td>
                      <td className="py-1 px-2 text-right font-semibold text-[#C61D21]">
                        ₹
                        {(
                          quantities[flower.id] * flower.price
                        ).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="border-t-2 border-[#C61D21]">
                    <td
                      colSpan={3}
                      className="py-2 px-2 text-right font-bold text-base lg:text-lg"
                    >
                      Flower Seva Total:
                    </td>
                    <td className="py-2 px-2 text-right font-bold text-base lg:text-lg text-[#C61D21]">
                      ₹{flowerSevaTotal.toLocaleString()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>

        {/* Section 4 – Annadaan Seva */}
        <div className="mt-5 mb-2 w-full flex flex-col items-center justify-center bg-[#C61D21] p-1">
          <h1 className="text-white text-3xl md:text-5xl font-semibold mb-4 p-2">
            Annadaan Seva
          </h1>

          <div className="grid grid-cols-2 gap-2 mt-2 w-full lg:w-[95%] px-1">
            {paymentOptions.slice(1).map((option, index) => (
              <button
                key={index}
                onClick={() => setAmount(option.amount)}
                className="bg-[#F9E7D0] text-red-800 text-center py-1 rounded-xl focus:bg-[#FAC785] focus:outline-none transition"
              >
                <p className="text-black text-lg lg:text-xl font-bold">
                  ₹{option.amount.toLocaleString()}
                </p>
                <p className="text-black text-sm lg:text-lg">
                  ({option.plates} Plates)
                </p>
              </button>
            ))}
          </div>

          {/* Custom Amount Input */}
          <div className="my-6 w-full lg:w-[95%] px-1 rounded-xl">
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full text-lg px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
              placeholder="₹ Donate As You Wish"
            />
          </div>
        </div>

        {/* Section 6 – Donation Form */}
        <div className="w-full flex flex-col items-center justify-center px-4 sm:px-6">
          <form className="w-full lg:w-[70%] border-2 border-solid border-[#C61D21] bg-[#F9E7D0] rounded-lg p-4 shadow-lg">
            <h2 className="text-xl font-bold mt-6 mb-4 text-center">
              Personal Details
            </h2>

            <div className="mb-4">
              <input
                type="text"
                name="donorName"
                value={formData.donorName}
                onChange={handleChange}
                placeholder="Donor Name *"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email ID"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="tel"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                placeholder="Mobile Number *"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
              />
              <p className="text-sm lg:text-lg text-black mt-1">
                (Sankalpa and Archana will be performed for you on your
                birthday)
              </p>
            </div>

            {/* 80G Certificate */}
            <div className="mb-2 flex items-center">
              <input
                type="checkbox"
                name="receiveCertificate"
                checked={formData.receiveCertificate}
                onChange={handle80GCheckboxChange}
                className="mr-2"
              />
              <label className="text-sm lg:text-lg">
                I would like to receive 80(G) Certificate
              </label>
            </div>
            {show80GDetails && (
              <div className="mb-2">
                <p className="text-black text-sm lg:text-base text-left">
                  Finance Act 2021 mandates uploading donation details for 80(G)
                  deductions. Ensure PAN and address details are provided.
                </p>
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber}
                  onChange={handleChange}
                  placeholder="Pan Number *"
                  className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                  required
                />
              </div>
            )}

            {/* Maha Prasadam */}
            <div className="mb-3 flex items-center">
              <input
                type="checkbox"
                name="receivePrasadam"
                checked={formData.receivePrasadam}
                onChange={handleMahaPrasadamCheckboxChange}
                className="mr-2"
              />
              <label className="text-sm lg:text-lg">
                I would like to receive Maha prasadam (Only within India)
              </label>
            </div>
            {showMahaPrasadamDetails && (
              <div className="my-3 flex flex-col space-y-2">
                {[
                  { name: "doorNumber", placeholder: "Door Number" },
                  {
                    name: "houseName",
                    placeholder: "House / Apartment / Building Name",
                  },
                  { name: "streetName", placeholder: "Street Name" },
                  { name: "area", placeholder: "Location / Area" },
                  { name: "city", placeholder: "City" },
                  { name: "state", placeholder: "State" },
                  { name: "country", placeholder: "Country" },
                  { name: "pincode", placeholder: "Pincode" },
                ].map((field) => (
                  <input
                    key={field.name}
                    type="text"
                    name={field.name}
                    placeholder={field.placeholder}
                    className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none"
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                ))}
              </div>
            )}

            <p className="text-xs lg:text-lg text-gray-400 mb-2">
              By continuing, you are agreeing to our{" "}
              <button
                type="button"
                onClick={() => {}}
                className="text-yellow-500 underline bg-none border-none cursor-pointer p-0"
              >
                Terms of Use
              </button>{" "}
              and{" "}
              <button
                type="button"
                onClick={() => {}}
                className="text-yellow-500 underline bg-none border-none cursor-pointer p-0"
              >
                Privacy Policy
              </button>
              .
            </p>
          </form>

          {/* Payment Breakdown */}
          {formData.totalAmount > 0 && (
            <div className="w-full lg:w-[70%] mt-4 bg-[#FFF5EC] border border-[#C61D21] rounded-lg p-4">
              <h3 className="text-base lg:text-lg font-bold text-[#C61D21] mb-2">
                💳 Payment Breakdown
              </h3>
              <div className="flex flex-col gap-1 text-sm lg:text-base">
                {Number(amount) > 0 && (
                  <div className="flex justify-between">
                    <span>Annadaan Seva</span>
                    <span className="font-semibold">
                      ₹{Number(amount).toLocaleString()}
                    </span>
                  </div>
                )}
                {flowerSevaTotal > 0 && (
                  <div className="flex justify-between">
                    <span>Flower Seva</span>
                    <span className="font-semibold">
                      ₹{flowerSevaTotal.toLocaleString()}
                    </span>
                  </div>
                )}
                <div className="flex justify-between border-t border-[#C61D21] pt-2 mt-1 font-bold text-base lg:text-lg text-[#C61D21]">
                  <span>Total Amount</span>
                  <span>₹{formData.totalAmount.toLocaleString()}</span>
                </div>
              </div>
            </div>
          )}

          <button
            onClick={handleSubmit}
            className="w-full lg:w-[30%] lg:text-xl bg-yellow-500 text-black font-bold py-2 mt-3 rounded-lg hover:bg-yellow-600 transition-colors"
          >
            Donate {formData.totalAmount ? `₹${formData.totalAmount}` : ""}
          </button>
        </div>

        <AccountDetails />

        {/* Section 9 – After Donation */}
        <div className="text-left md:mx-44 pb-10 p-2 mb-5 w-full px-4 sm:px-8">
          <h2 className="text-3xl text-[#C61D21] text-left font-bold">
            After Donation:
          </h2>
          <p className="md:text-2xl mt-4 text-base text-black w-full text-justify font-semibold">
            Once you have donated, please share the transaction details or
            receipt via WhatsApp at{" "}
            <span className="text-red-600">+91 9955685568</span>. This helps us
            acknowledge your contribution and issue a receipt for tax exemption
            under Section 80G of the Income Tax Act.
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HighLightFestival;
